import { useMutation, useQueryClient } from "@tanstack/react-query";
import { ControleQuinquennalApi } from "../controle-quinquennal.api";
import { controleQuinquennalKeys } from "./controle-quinquennal.keys";

/**
 * MR-G — Ré-émission unitaire d'un sous-axe FAILED/timeout de l'axe assujetti.
 * Invalide la lecture des vérifications du même axe : le polling du hook de
 * lecture suit ensuite le PENDING jusqu'au résultat.
 */
export const useRelaunchSubAxisMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      idControleQuinquennal,
      idAxe,
      subAxis,
    }: {
      idControleQuinquennal: string;
      idAxe: string;
      subAxis: string;
    }) =>
      ControleQuinquennalApi.relaunchSubAxisAnalysis(
        idControleQuinquennal,
        idAxe,
        subAxis
      ),
    onSettled: (_data, _error, { idControleQuinquennal, idAxe }) => {
      void queryClient.invalidateQueries({
        queryKey: controleQuinquennalKeys.axeVerifications(
          idControleQuinquennal,
          idAxe
        ),
      });
    },
  });
};
